import Component from '@glimmer/component';
import FormRow from '../row.gts';
import type { HeadlessFormComponentSignature } from 'ember-headless-form/components/headless-form';
import { type UserData } from '../../../../-private/types.ts';
import type { FormData, FormKey } from 'ember-headless-form';
import AnnotatedInput, {
  type WrFormAnnotedInputComponentSignature
} from '../annotated-input.gts';

export interface WrFormInputRowSignature<
  DATA extends UserData,
  KEY extends FormKey<FormData<DATA>> = FormKey<FormData<DATA>>
> {
  Element: WrFormAnnotedInputComponentSignature<DATA, KEY>['Element'];
  Args: {
    label: string;
    confirmation?: string;
    blurOnWheel?: boolean;
    form: HeadlessFormComponentSignature<DATA, unknown>['Blocks']['default'][0];
    name: KEY;
  };
  Blocks: {
    default?: [];
  };
}

export default class WrFormFieldsRowsInputComponent<
  DATA extends UserData
> extends Component<WrFormInputRowSignature<DATA>> {
  <template>
    <@form.Field @name={{@name}} as |field|>
      <FormRow>
        <:header>
          <field.Label for={{field.id}}>{{@label}}</field.Label>
        </:header>

        <:col1>
          <AnnotatedInput
            @name={{@name}}
            @field={{field}}
            @confirmation={{@confirmation}}
            @blurOnWheel={{@blurOnWheel}}
            ...attributes
          />
        </:col1>

        <:col2>{{yield}}</:col2>
      </FormRow>
    </@form.Field>
  </template>
}
